export default __webpack_public_path__ + "static/media/step_1.e520f5bd.png";